import React, { useState } from 'react'
import { addDoc, collection } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'
import { auth, db } from '../firebase'
import { ShopFormLayout } from '../layouts/ShopFormLayout'
import { uploadToCloudinary } from '../utils/uploadToCloudinary'

export const CreateShopPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    address: '',
    tags: '',
    imageUrl: '',
  })
  const navigate = useNavigate()

  // フォームデータ変更時の汎用ハンドラ
  const handleFormDataChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  // 送信処理
  const handleSubmit = async (file: File | null) => {
    let uploadImageUrl = ''
    if (file) {
      uploadImageUrl = await uploadToCloudinary(file)
    }

    const user = auth.currentUser
    if (!user) {
      navigate('/login')
      return
    }

    const shopData = {
      ...formData,
      tags: formData.tags.trim()
        ? formData.tags
            .split(/[、,]/)
            .map((tag) => tag.trim())
            .filter((tag) => tag.length > 0)
        : [],
      imageUrl: uploadImageUrl,
      createdAt: new Date(),
      userId: user.uid,
    }

    await addDoc(collection(db, 'shops'), shopData)
    navigate('/')
  }

  return (
    <ShopFormLayout
      title="お店を追加"
      formData={formData}
      onFormDataChange={handleFormDataChange}
      onSubmit={handleSubmit}
    />
  )
}
